import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";

/**
 * IntegrationTypeStepObjectBaseComponent
 *
 * ObjectBaseComponent for hc.IntegrationTypeStep entity.
 * This component serves as the main entry point for displaying IntegrationTypeStep details
 * and delegates rendering to mode-specific view components (side/full).
 *
 * Child entities managed via navigation:
 * - hc.IntegrationStep (integrationTypeStep FK)
 * - hc.IntegrationTypeStepInput (step FK)
 * - hc.IntegrationTypeStepOutput (step FK)
 * - hc.IntegrationTypeStepTransition (fromStep/toStep FK)
 *
 * @see IntegrationTypeStepSideComponent - Side panel view
 * @see IntegrationTypeStepFullComponent - Full page view
 */
@Component({
    selector: 'hc-integration-type-step-object-base-component',
    templateUrl: 'integration-type-step-object-base.component.html',
    styleUrls: ['integration-type-step-object-base.component.scss'],
    standalone: false
})
export class IntegrationTypeStepObjectBaseComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    name: string = "Integration Type Step Object";

    ngOnInit() {
        super.ngOnInit();
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    onObjectChanged() {
        if (this.dto) {
            this.setPageTitle(this.dto.name || this.name);
        }
    }

}
